import React from 'react';
import { StickyAnnouncementBar } from './components/StickyAnnouncementBar';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { Hero } from './components/Hero';
import { WhyThisWorksSection } from './components/WhyThisWorksSection';
import { TransformationSection } from './components/TransformationSection';
import { BonusStack } from './components/BonusStack';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { InsidePreviewSection } from './components/InsidePreviewSection';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <StickyAnnouncementBar data-id="element-1" />
      <StickyMobileCTA data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <WhyThisWorksSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <TransformationSection data-id="element-7" />
        <InsidePreviewSection data-id="element-8" />
        <BonusStack data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <FinalCTASection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}